import React from 'react'
import BulkActivation from '../../Component/Activation/BulkActivation'

const BulkActivationPage = () => {
  return (
    <div className='page-body'>
        <BulkActivation/>
    </div>
  )
}

export default BulkActivationPage